<template>
    <div v-cloak>
        <div class="row">

            <div class="col-md-12">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'home'}">{{$t("inicio")}}</router-link>
                        </li>
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'configuracion'}">{{$t("configuracion")}}</router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">{{$t("datosFiscales")}}</li>
                    </ol>
                </nav>
            </div>


            <div class="col-md-12" v-if="respuesta">
                <div class="card">

                    <div class="table-responsive">
                        <table class="table table-bordered table-striped">
                            <thead class="thead-dark">
                            <tr>
                                <th>{{$t("nombreFiscal")}}</th>
                                <th>{{$t("cifNif")}}</th>
                                <th>{{$t("email")}}</th>
                                <th>{{$t("direccion")}}</th>
                                <th width="10%">{{$t("acciones")}}</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="company in companies">
                                <td>
                                    <div>{{company.fiscalName}}</div>
                                </td>
                                <td>
                                    <div>{{company.nif}}</div>
                                </td>
                                <td>
                                    <div>{{company.email}}</div>
                                </td>
                                <td>
                                    <div>{{company.address}}</div>
                                </td>
                                <td>
                                    <div><a @click="openModal(company)" class="btn btn-danger btn-link btn-xs">
                                        <i v-tooltip.top-center="$i18n.t('editar')" class="fas fa-pencil-alt"
                                           style="color: orange"></i>
                                    </a>
                                    </div>

                                </td>

                            </tr>
                            </tbody>
                        </table>
                    </div>

                </div>
            </div>
        </div>

        <modal name="modal-edit-company" :adaptive=true :scrollable=true height="auto" :clickToClose=false>
            <div>
                <div class="modal-header">
                    <h4 style="margin: 0px">{{$t("datosFiscales")}}</h4>
                </div>
                <div class="modal-body">

                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="nombreFiscal">{{$t("nombreFiscal")}} *</label>
                                <input type="text" class="form-control"
                                       id="nombreFiscal" v-model="company.fiscalName">
                            </div>
                        </div>

                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="email">{{$t("email")}}</label>
                                <input type="text" class="form-control"
                                       id="email" v-model="company.email">
                            </div>
                        </div>

                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="telefono">{{$t("telefono")}}</label>
                                <input type="text" class="form-control"
                                       id="telefono" v-model="company.phone">
                            </div>
                        </div>

                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="direccion">{{$t("direccion")}}</label>
                                <input type="text" class="form-control"
                                       id="direccion" v-model="company.address">
                            </div>
                        </div>

                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="city">{{$t("ciudad")}}</label>
                                <input type="text" class="form-control"
                                       id="city" v-model="company.city">
                            </div>
                        </div>

                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="country">{{$t("pais")}}</label>
                                <input type="text" class="form-control"
                                       id="country" v-model="company.country">
                            </div>
                        </div>

                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="cp">{{$t("codigoPostal")}}</label>
                                <input type="text" class="form-control"
                                       id="cp" v-model="company.cp">
                            </div>
                        </div>

                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="nif">{{$t("cifNif")}} *</label>
                                <input type="text" class="form-control"
                                       id="nif" v-model="company.nif">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <div align="right" class="col-12">

                        <button class="btn btn-danger" @click="closeModal()"><i class="fa fa-window-close"></i>
                            {{$t("cancelar")}}
                        </button>

                        <button class="btn btn-primary" @click="saveDatosFiscales()"><i class="fa fa-check-square"></i>
                            {{$t("guardar")}}
                        </button>

                    </div>
                </div>
            </div>
        </modal>

    </div>
</template>
<script>
    import {DatePicker, Select, Option, Dropdown, DropdownItem, DropdownMenu, Button} from 'element-ui'
    import {Loading} from 'element-ui';
    import swal from 'sweetalert2'
    import moment from 'moment'

    export default {
        created() {
//            this.loading = Loading.service({text: 'Cargando...'});
            this.$store.dispatch("setNameRoute", this.$i18n.t("datosFiscales"));
            this.getCompanies();
        },
        components: {
            [DatePicker.name]: DatePicker,
            [Select.name]: Select,
            [Dropdown.name]: Dropdown,
            [DropdownItem.name]: DropdownItem,
            [DropdownMenu.name]: DropdownMenu,
            [Button.name]: Button,
            [Option.name]: Option
        },
        data() {
            return {
                loading: false,
                company: {},
                companies: ["-"], // Pongo '-' para cuando cargue la vista no se vea el rojo de no hay elementos
                respuesta: true,
                name: "",
            }
        },
        watch: {
            '$route'(to, from) {
                if (to.params.pag) {
                    this.pag = to.params.pag;
                    this.getRangosHorarios();
                } else if (to.params.query) {
                    this.query = to.params.query;
                    this.getRangosHorarios();
                }
            }
        },
        methods: {
            getCompanies() {
                var config = {
                    params: {
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "datosfiscales/getCompaniesByUser", config)
                    .then(function (response) {
                        vm.companies = response.data.result;
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            saveDatosFiscales() {

                console.log(this.company);

                if (this.company.fiscalName === '') {
                    swal({
                        title: this.$t('atencion'),
                        text: this.$t('elCampoNombreFiscalEsObligatorio'),
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });

                }
                else if(this.company.nif === ''){

                    swal({
                        title: this.$t('atencion'),
                        text: this.$t('elCampoCifNifEsObligatorio'),
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });
                }
                else {

                    var config = {
                        params: {
                            jwt: this.$store.getters.jwt
                        },
                        headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                    };
                    var params = {
                        company: this.company,
                        jwt: this.$store.getters.jwt,
                    };

                    let vm = this;
                    this.axios.post(this.$store.getters.apiUrl + 'datosfiscales/saveDatosFiscales', params, config)
                        .then(function (response) {

                            if (response.data.response) {
                                vm.$notify({
                                    message: vm.$t('datosActualizadosCorrectamente'),
                                    icon: 'nc-icon nc-check-2',
                                    timeout: 2000,
                                    horizontalAlign: 'right',
                                    verticalAlign: 'top',
                                    type: 'success'
                                });

                                vm.getCompanies();

                                vm.$modal.hide("modal-edit-company");

                            } else {
                                swal({
                                    title: vm.$t('atencion'),
                                    text: response.data.message,
                                    confirmButtonClass: 'btn btn-info btn-fill',
                                    type: 'error'
                                });
                            }
                        }).catch(function (error) {
                        console.log(error);
                    });
                }
            },
            closeModal() {
                this.$modal.hide("modal-edit-company");
                this.company = {};
            },
            openModal(company) {
                this.company = company;
                this.$modal.show("modal-edit-company");

            }

        }

    }
</script>

<style scoped>

    [v-cloak] {
        display: none;
    }

    tbody tr:hover {
        background-color: rgba(0, 153, 130, 0.2);
    }

    tbody td {
        padding: 0 !important;
    }

    td div {
        padding: 12px 8px;
        color: #333;
    }

    .buttonsSearch:hover {
        cursor: pointer;
        background-color: rgba(0, 153, 130, 0.1);
    }

    .card {
        padding: 20px;
    }

    .input-group button {
        height: 40px;
    }
</style>




// WEBPACK FOOTER //
// src/pages/Dashboard/Configuracion/General/DatosFiscales.vue